<mat-divider></mat-divider>
<div class="mc-divider-content">
  <ng-content></ng-content>
</div>
<mat-divider></mat-divider>